import { API_ROUTES, organizationDeletionSchema } from '@hvac/contracts';
import { queryOptions } from '@tanstack/react-query';
import { z } from 'zod';
import { apiClient } from './queries.js';

/** A pending request to delete the business. Every member can see it. */
export const deletionQuery = (organizationId: string) =>
  queryOptions({
    queryKey: ['deletion', organizationId] as const,
    queryFn: ({ signal }) =>
      apiClient.request({
        path: API_ROUTES.deletion.request(organizationId),
        schema: organizationDeletionSchema.nullable(),
        signal,
      }),
    staleTime: 60_000,
  });

export function requestDeletion(
  organizationId: string,
  confirmName: string,
  password: string,
  reason?: string,
) {
  return apiClient.request({
    path: API_ROUTES.deletion.request(organizationId),
    method: 'POST',
    body:
      reason === undefined || reason.trim() === ''
        ? { confirmName, password }
        : { confirmName, password, reason },
    schema: organizationDeletionSchema.nullable(),
  });
}

export function cancelDeletion(organizationId: string) {
  return apiClient.request({
    path: API_ROUTES.deletion.request(organizationId),
    method: 'DELETE',
    schema: z.object({ cancelled: z.boolean() }),
  });
}
